import {AppConfig} from '@frontend/AppConfig'
import type {NewChatMessageEventData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {AddReviewModal} from '@frontend/modules/public/seller_info/components/AddReviewModal'
import {FadeSwitch} from 'swayok-react-mdb-ui-kit/components/Animation/FadeSwitch'
import {WebSocketEventsHandler} from 'swayok-react-mdb-ui-kit/components/WebSockets/WebSocketEventsHandler'
import {ChatDetailsCard} from './ChatDetailsCard'
import {ChatsList} from './ChatsList'
import {useChatsPageContentApi} from './hooks/useChatsPageContentApi'

interface ChatsPageContentProps {
    miniChat?: boolean
    // Открывает в мини-чате определенный чат (по запросу извне).
    selectedChatId?: null | number
    // Вызывается после обработки свойства selectedChatId.
    resetSelectedChatProp?: () => void
}

// Содержимое страницы с чатами или мини-чата.
export function ChatsPageContent(props: ChatsPageContentProps) {

    const {
        miniChat,
    } = props

    const {
        userId,
        chats,
        isProcessing,
        isAllChatsLoaded,
        filter,
        chatForReview,
        isAddReviewAboutSellerModalVisible,
        setIsAddReviewAboutSellerModalVisible,

        selectedChat,
        onChatSelect,
        deleteChats,
        readAllMessagesInChats,
        showAddReviewModal,
        onChatsListUpdate,
        receivedNewChatMessage,
        onReviewAdded,
        setChatForReview,
        onLatestMessagesLoaded,
    } = useChatsPageContentApi(props)

    if (!userId) {
        return null
    }

    return (
        <div>
            <FadeSwitch transitionKey={selectedChat !== null}>
                {selectedChat ? (
                    <ChatDetailsCard
                        miniChat={miniChat}
                        chat={selectedChat}
                        onBack={() => onChatSelect(null)}
                        onDelete={chat => deleteChats([chat.id])}
                        onReadAllMessages={chat => readAllMessagesInChats([chat.id])}
                        onAddReview={showAddReviewModal}
                        onLatestMessagesLoaded={onLatestMessagesLoaded}
                        isProcessing={isProcessing}
                    />
                ) : (
                    <ChatsList
                        miniChat={miniChat}
                        chats={chats}
                        isAllChatsLoaded={isAllChatsLoaded}
                        filter={filter}
                        setChat={onChatSelect}
                        setChats={onChatsListUpdate}
                        onDelete={deleteChats}
                        onReadAllMessages={readAllMessagesInChats}
                        onAddReview={showAddReviewModal}
                        isProcessing={isProcessing}
                    />
                )}
            </FadeSwitch>
            {chats !== null && (
                <WebSocketEventsHandler<NewChatMessageEventData>
                    key={'chats-list-new-message' + (miniChat ? '-mini-chat' : '')}
                    subscriptionId={'chats-list-new-message' + (miniChat ? '-mini-chat' : '')}
                    event={AppConfig.websocketEvent.newChatMessage}
                    handler={receivedNewChatMessage}
                />
            )}
            <AddReviewModal
                chatId={chatForReview?.id ?? null}
                reviewType={chatForReview?.reviewType ?? 'seller'}
                show={isAddReviewAboutSellerModalVisible}
                onClose={() => {
                    setIsAddReviewAboutSellerModalVisible(false)
                }}
                onClosed={() => {
                    setIsAddReviewAboutSellerModalVisible(null)
                    setChatForReview(null)
                }}
                onReviewAdded={onReviewAdded}
            />
        </div>
    )
}
